// Product Color Swatches Functionality
// This script handles image switching, title updates, and URL updates for product color swatches

document.addEventListener('DOMContentLoaded', function () {
  // Handle clickable swatches for image switching
  const clickableSwatches = document.querySelectorAll('.custom-color-swatch.clickable');

  clickableSwatches.forEach((swatch) => {
    const productId = swatch.dataset.productId;
    const productImageContainer = document.getElementById(`product-image-${productId}`);

    // Click event for image switching
    swatch.addEventListener('click', function (e) {
      e.preventDefault();

      const newImageUrl = this.dataset.mainImage;
      const newColorName = this.dataset.color;
      const productTitle = this.dataset.productTitle;
      const productUrl = this.dataset.productUrl;
      const productHandle = this.dataset.productHandle;

      if (productImageContainer && newImageUrl) {
        // Add fade effect
        productImageContainer.classList.add('fade-out');

        // Update the image after a short delay for smooth transition
        setTimeout(() => {
          // Create single image HTML (no hover image)
          const newImageHtml = `<img src="${newImageUrl}" alt="${productTitle}" class="img-fluid">`;

          // Replace the image container content
          productImageContainer.innerHTML = newImageHtml;

          // Remove fade effect
          productImageContainer.classList.remove('fade-out');
        }, 150);
      }

      // Update product title
      const titleElement = document.getElementById(`product-title-${productId}`);
      if (titleElement && productTitle) {
        titleElement.textContent = productTitle;
        titleElement.href = productUrl;
        titleElement.title = productTitle;
      }

      // Update product link
      const linkElement = document.getElementById(`product-link-${productId}`);
      if (linkElement && productUrl) {
        linkElement.href = productUrl;
      }

      // Update quickview button handle
      const quickviewBtn = document.getElementById(`quickview-btn-${productId}`);
      if (quickviewBtn && productHandle) {
        quickviewBtn.setAttribute('data-handle', productHandle);
      }

      // Update selected state
      const allSwatches = document.querySelectorAll(`[data-product-id="${productId}"]`);
      allSwatches.forEach((s) => {
        s.classList.remove('selected');
        s.classList.add('clickable');
      });

      this.classList.add('selected');
      this.classList.remove('clickable');
    });
  });
  // Add this after your existing swatch click handler
document.querySelectorAll('.swatch-more-btn').forEach(btn => {
  btn.addEventListener('click', function() {
    const productId = this.dataset.productId;
    const hiddenSwatches = document.querySelectorAll(`[data-product-id="${productId}"].hidden-swatch`);
    
    hiddenSwatches.forEach(swatch => {
      swatch.classList.remove('hidden-swatch');
    });
    
    this.style.display = 'none';
  });
});
});